module.exports = __webpack_public_path__ + "static/media/stars_1920.b093460d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stars_1920.jpg
// module id = 28
// module chunks = 0